/* eslint-disable */

/** unique or primary key constraints on table "argo.attribute_data" */
export enum ArgoAttributeDataConstraint {
  /** unique or primary key constraint on columns "attribute_data_id" */
  AttributeDataPkey = 'attribute_data_pkey',
  /** unique or primary key constraint on columns "context_id", "attribute_id", "attribute_schema_definition_id" */
  AttributeDataUnique = 'attribute_data_unique'
}

/** select columns of table "argo.attribute_data" */
export enum ArgoAttributeDataSelectColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  AttributeSchemaDefinitionId = 'attribute_schema_definition_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_attribute_data_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.attribute_data" */
export enum ArgoAttributeDataSelectColumnArgoAttributeDataAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_attribute_data_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.attribute_data" */
export enum ArgoAttributeDataSelectColumnArgoAttributeDataAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.attribute_data" */
export enum ArgoAttributeDataUpdateColumn {
  /** column name */
  AttributeId = 'attribute_id',
  /** column name */
  AttributeSchemaDefinitionId = 'attribute_schema_definition_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

